
/* eslint-disable */
import React, { useState, Fragment, useRef } from 'react';
import ReactDOM from 'react-dom/client';
import { useParams } from "react-router-dom";
import axios from 'axios';
import { useQuery, keepPreviousData } from '@tanstack/react-query';
import { QueryClientProvider, QueryClient } from '@tanstack/react-query';

import useGlobalStore from '../store.js';
import ExtraBox from './log.compoennts.jsx'

const queryClient = new QueryClient();
export default function NewReport() {
    const { id } = useParams();

    const { token, headers, host, noAuth } = useGlobalStore();

    const [page, setPage] = useState(host + '/new_report?page=0')
    const myInputRef = useRef(null);
    const fetchProjects = async (page = host + '/new_report?page=0') => {
        try {
            const response = await axios.post(page, { "flow_id": id }, headers);
            return response.data.data;
        } catch (error) {
            throw error;
        }
    }


    const { isPending, isError, error, data, isFetching, isPlaceholderData } = useQuery({
        queryKey: ['reportData', page],
        queryFn: () => fetchProjects(page),
        placeholderData: keepPreviousData,
    })
    if (!token) noAuth()
    if (isPending) return <p>Loading....</p>
    if (isError) {
        // if (error != null) {
        //     if (error.response.status == '401') noAuth()
        // }
    }


    const PaginationBtn = () => {
        return (
            <div className="mx-auto max-w-5xl pt-6 flex justify-center">
                {
                    data.links.map(i => {
                        return <button type='button' onClick={() => setPage(i.url)}
                                className="bg-blue-200 text-blue-500 font-semibold mx-2 py-2 px-4 rounded-md"
                            >{i.label.replace(/&raquo;/g, '»').replace(/&laquo;/g, '«')}</button>
                    })
                }
                {isFetching ? <span> Loading...</span> : null}
            </div>
        )
    }


    const GetLogDetails = (detailData) => {
        const main_box = myInputRef.current
        ReactDOM.createRoot(main_box.querySelector("#extra_box"))
        .render(
            <Fragment>
                <QueryClientProvider client={queryClient}>
                    <ExtraBox detailData={detailData} flow_id={id} />
                </QueryClientProvider>
            </Fragment>
        );
    }

    return (
        <div className="row" ref={myInputRef}>
            <div className="col-md-6">
                <table className="table table-header-bg">
                    <thead>
                        <tr className="table_my_th">
                            <th scope="col">Run ID</th>
                            <th scope="col">Number</th>
                            <th scope="col">Total</th>
                            <th scope="col">Action</th>
                        </tr>
                    </thead>
                    <tbody>
                    {
                        data.data.map(item => {
                            return (
                                <tr>
                                    <td>{item.run_id}</td>
                                    <td>{item.receiver}</td>
                                    <td>{item.total}</td>
                                    <td><button type='button' onClick={e => GetLogDetails(item)}> Get Details</button></td>
                                </tr>
                            )
                        })
                    }
                    </tbody>
                </table>
                <PaginationBtn />
            </div>
            <div className="col-md-6" id="extra_box"></div>
        </div>
    )
}